import { useEffect } from "react";
import { matchesRoutePrefix } from "./routeMatch";

// Shared by every screen in the Task module (Tasks, TaskDetail, AddTasks) so
// the saved Task List filter state (localStorage) and the "still inside the
// module" flag (sessionStorage) are defined once and stay in sync everywhere.
export const TASK_STATE_KEY = "taskFiltersState";
export const TASK_MODULE_FLAG = "insideTaskModule";
export const TASK_ROUTES = [
  "/admin/tasks",
  "/admin/task/view",
  "/admin/addtasks",
];
export const isTaskModulePath = (path = "") =>
  TASK_ROUTES.some(route => matchesRoutePrefix(path, route));

// Clears the saved filter state only when navigating away from the Task
// module entirely, not for in-module navigation (e.g. list -> detail -> back).
export const useClearTaskStateOnExit = (history) => {
  useEffect(() => {
    const clearModuleState = () => {
      sessionStorage.removeItem(TASK_MODULE_FLAG);
      localStorage.removeItem(TASK_STATE_KEY);
    };

    const unlisten = history.listen(({ pathname }) => {
      if (!isTaskModulePath(pathname)) {
        clearModuleState();
      }
    });

    return () => {
      unlisten();
      if (!isTaskModulePath(history.location.pathname)) {
        clearModuleState();
      }
    };
  }, [history]);
};
